// Public backend configuration. The fallback keeps published builds working even
// if the host does not inject Vite env vars during compilation.
export const SUPABASE_CONFIG = {
  url: (import.meta.env.VITE_SUPABASE_URL || 'https://lkiijlvzbpkvcdbcwtey.supabase.co') as string,
  anonKey: (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxraWlqbHZ6YnBrdmNkYmN3dGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1NDc4NTUsImV4cCI6MjA5NTEyMzg1NX0.HUuxx4udXjLaxXym5HfxkabwMr7Lep01GQ9INrU7-z0') as string,
};

export const isSupabaseConfigured = () => {
  return Boolean(SUPABASE_CONFIG.url && SUPABASE_CONFIG.anonKey);
};